<template>
	<div class="detail-page">
		
		<!-- 单页 -->
		<section class="page-ctn" >
			<div class="page-main">
				<!-- 面包屑 -->
				<div class="bread-crumbs" v-if="detailData">
					<!-- <span>您的位置：</span> -->
					<a href="javascript:;" @click="goUrl({name:'pageIndex'})">首页</a> /
					<!-- <a href="javascript:;" @click="goUrl({name:'pageList',params:{catid:detailData.catid}})">{{detailData.catename}}</a> / -->
					<!-- <p v-if="detailData">{{detailData.catename}}</p> -->
					<p v-if="detailData">{{detailData.catename}}</p>
				</div>
				
				<div class="detail-mdl" v-if="detailData">
					<div class="tit-img"><img src="../../assets/img/detail-tit.png" alt=""></div>
					<h2 class="detail-title">{{detailData.catename}}</h2>
					<!-- <div class="detail-info">
						<span>作者：{{detailData.author}}</span>
						<span>发布时间：{{detailData.inputtime}}</span>
						<span>浏览次数：{{detailData.hits}}</span>
					</div> -->
					<div class="detail-ctn" v-html="detailData.content"></div>
				</div>
			</div>
		</section>
		
	</div>
</template>

<script>
import pageMixin from '@/mixins/page.js'
export default {
	mixins: [pageMixin],
	name: 'pageIndex',
	data () {
		return {
			detailId:'',
			detailData:null,
		}
	},
	
	created(){
		this.detailId = this.$route.query.catid?this.$route.query.catid:''
		this.detailCode = this.$route.query.code?this.$route.query.code:''
		this.getDetail()
	},
	 
	
	//防止
	beforeRouteUpdate (to, from, next) {
		this.detailId = to.params.id?to.params.id:''
		next() // 一定要有next
	},
  
	methods:{
		
		getDetail(){
			if(this.listLoading){return}
			this.listLoading = true
			this.$axios({
				url:'/index.php?s=common&c=api&m=getCategoryDetail',
				params:{
					catid	: this.detailId,
					code	: this.detailCode
				},
				success:(res)=>{
					var detailData =  res.data
					detailData.content = detailData.content.replace(/\<img/gi, '<img style="max-width:100%; margin-bottom:10px;"');
					this.detailData = detailData
				},
				complete:()=>{
					this.listLoading = false
				}
			})
		},
		
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.detail-page{ background:url(../../assets/img/detail-bg.jpg) repeat-y center top; background-size:1920px auto;  padding-top:0;}
.detail-mdl{
	padding:40px 0 80px; width:820px; margin:0 auto;
	.tit-img{text-align:center; margin-bottom:40px;}
	.detail-title{ text-align: center; font-size:28px; color:#333; line-height:36px; margin-bottom:50px; font-family:"黑体","Microsoft YaHei","PingFang SC","Lantinghei SC","HanHei SC","Helvetica Neue","Open Sans",Arial,"Hiragino Sans GB","微软雅黑",STHeiti,"WenQuanYi Micro Hei",SimSun,sans-serif;}
	.detail-info{
		text-align:center; margin-bottom:60px;
		span{display:inline-block; margin:0 15px; font-size:14px; color:#999;}
	}
	.detail-ctn{
		width: 820px; margin:0 auto; 
		/deep/img{max-width:100%; margin-bottom:10px;}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/index2.vue